import { FC, ReactElement, useEffect, useState } from 'react'
import styled from 'styled-components'
import { useTransition, animated, config } from '@react-spring/web'
import { IoFilterOutline } from 'react-icons/io5'

interface ScrollUpButtonProps {
  anchorRef: HTMLElement | null
  mainRef: HTMLElement | null
  forceHide?: boolean
}

const ScrollUpButton: FC<ScrollUpButtonProps> = ({
  anchorRef,
  mainRef,
  forceHide = false,
}): ReactElement => {
  const [showFiltersButton, setShowFiltersButton] = useState<boolean>(false)
  const [leftPosition, setLeftPosition] = useState<number>(0)
  const transition = useTransition(forceHide ? false : showFiltersButton, {
    from: { opacity: 0, translateY: 10 },
    enter: { opacity: 1, translateY: 0 },
    leave: { opacity: 0, translateY: 10 },
    delay: 200,
    config: showFiltersButton ? config.wobbly : config.gentle,
  })

  const mainIntersectionCallback = (entries: any) => {
    entries.forEach((entry: any) => {
      if (entry.isIntersecting) {
        console.log('Main intersecting')
        console.log(entry)
        setShowFiltersButton(true)
      } else {
        console.log('Main not intersecting')
        console.log(entry)
        console.log('Hide button')
        setShowFiltersButton(false)
      }
    })
  }

  useEffect(() => {
    if (mainRef) {
      onWindowResize()
      const mainObserver = new IntersectionObserver(mainIntersectionCallback, {
        root: null,
        threshold: mainRef
          ? Math.min(
              Math.max(
                0,
                (window.innerHeight - 0) /
                  mainRef.getBoundingClientRect().height
              ),
              1
            ) * 0.85
          : 0,
        rootMargin: '0px 0px 0px 0px',
      })

      console.log(mainRef.getBoundingClientRect().height)
      console.log(
        'Threshold',
        mainRef
          ? Math.min(
              Math.max(
                0,
                (window.innerHeight - 0) /
                  mainRef.getBoundingClientRect().height
              ),
              1
            )
          : 0
      )

      mainObserver.observe(mainRef)
    }
  }, [mainRef])

  const onWindowResize = () => {
    setLeftPosition(
      mainRef
        ? mainRef.getBoundingClientRect().left +
            mainRef?.getBoundingClientRect().width * 0.5
        : 0
    )
  }

  useEffect(() => {
    window.addEventListener('resize', onWindowResize)

    return () => {
      window.removeEventListener('resize', onWindowResize)
    }
  }, [mainRef])

  return (
    <>
      {transition(
        (style, item) =>
          item && (
            <Container
              onClick={() => {
                anchorRef?.scrollIntoView({ behavior: 'smooth' })
              }}
              style={{
                ...style,
                translateX: '-50%',
                left: `${leftPosition}px`,
              }}
            >
              <IoFilterOutline />
              &nbsp;&nbsp;Retour aux filtres
            </Container>
          )
      )}
    </>
  )
}

const Container = styled(animated.div)`
  cursor: pointer;
  background-color: ${({ theme }) => theme.mainColor};
  border-radius: 20px;
  position: fixed;
  bottom: 20px;
  transform: translateX(-50%);
  z-index: 1000;
  padding: 10px 20px;
  color: white;
  font-family: var(--font-sans-serif);
  font-size: 1.45rem;
  line-height: 1.1;
  white-space: nowrap;
`

export default ScrollUpButton
